import i18n from 'constants/translation/i18n';

const dependencyAreasBPR = (t?: any) => {
  const entries = [
    {
      area: 'riskToControl',
      title: t ? t('RISK_CONTROL_GAPS') : 'Risk - Control Gaps Dependency',
      href: '/dependency_bpr/risks_controls_gaps'
    },
    {
      area: 'processes',
      title: t ? t('PROCESSES') : 'Processes',
      href: '/dependency_bpr/processes'
    },
    {
      area: 'orgHierarchyProcessRiskControl',
      title: t ? t('PROCESS_RISK_CONTROL') : 'Process - Risk - Control',
      href: '/dependency_bpr/org-hierarchy-process-risk-control'
    },
    {
      area: 'orgHierarchyControlEffectiveness',
      title: t ? t('CONTROL_EFFECTIVENESS') : 'Control Effectiveness',
      href: '/dependency_bpr/org-hierarchy-control-effectiveness'
    }
  ];
  return entries;
};

export default dependencyAreasBPR;
